import {
  confirmDialog,
  CustomButton,
  CustomCollapseCard,
  CustomImage,
  CustomTable,
  successDialog,
  Text,
  useText,
} from '@src/components';
import React, { useCallback, useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import '@src/styles/pendingApproval/balanceOrder.scss';
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getPackagesList, updatePackages } from '@src/store/slice/packagesSlice';
import dayjs from '@src/utils/day';
import { setSelectedOrder } from '@src/store/slice/orderSlice';
import OrderSummaryCardModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryCardModal';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { getPendingNotifications } from '@src/store/slice/notificationSlice';
import { VouIdCode } from '@src/store/enums';
import PropTypes from 'prop-types';

function getExpandIcon() {
  return ({ expanded, onExpand, record }) =>
    expanded ? (
      <UpCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    ) : (
      <DownCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    );
}

function getExpandedRowRender(handleDeliveryApproved) {
  return (record) => (
    <div className="custom-expanded-row" key={record.id}>
      <div className="colum-title">
        <span>
          <Text t="orderDeliveryDate" />
        </span>{' '}
        <span>{dayjs(record.packageDate).format('DD/MM/YYYY HH:mm')}</span>
      </div>
      <div className="colum-title">
        <span>TESLİMAT ADRESİ:</span> <span>{record.deliveryAddress}</span>
      </div>

      <div className="mobile-action-btn">
        <CustomButton
          id="pendingApproval-deliveryApprovalList-custom-custom-btn-delivery-approved"
          onClick={() => handleDeliveryApproved(record)}
          className="custom-btn-delivery-approved"
          buttonAuthName="OrderDeliveryConfirmationGroup"
        >
          <Text t="confirmDelivery" />
        </CustomButton>
      </div>
    </div>
  );
}

const DEFAULT_TABLE_PROPERTY = {
  currentPage: 1,
  page: 1,
  pageSize: 10,
  totalCount: 0,
};

const DeliveryApprovedList = ({ isCompliments = false, isMarket = false }) => {
  const dispatch = useDispatch();
  const isMobil = useMediaQuery({ query: '(max-width: 1179.98px)' });

  const { isApproved } = useSelector((state) => state.packages);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const [packagesList, setPackagesList] = useState([]);
  const [tableProperty, setTableProperty] = useState(DEFAULT_TABLE_PROPERTY);

  const [expandedRowsApproved, setExpandedRowsApproved] = useState([]);
  const [orderSummaryCardModalVisible, setOrderSummaryCardModalVisible] = useState(false);

  let vouId;
  let cardTitle;

  if (isMarket) {
    vouId = VouIdCode.Market;
    cardTitle = 'Ticket Market';
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
    cardTitle = 'Ticket Gift';
  } else {
    vouId = VouIdCode.Restaurant;
    cardTitle = 'Ticket Restaurant';
  }

  const collapseHeader = (
    <>
      {cardTitle} <Text t="cardDeliveryConfirmation" />
    </>
  );
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');

  useEffect(() => {
    loadPackagesList();
  }, [isApproved]);

  const getList = async (pageNumber = 1, pageSize = 10) => {
    const body = {
      customerId: selectedCustomer?.customerId,
      isDeliveredToCustomer: isApproved,
      vouId: vouId,
    };
    const action = await dispatch(getPackagesList({ body, pageNumber, pageSize }));
    if (getPackagesList.fulfilled.match(action)) {
      setPackagesList(action?.payload?.data?.items || []);
      setTableProperty(action?.payload?.data?.pagedProperty || DEFAULT_TABLE_PROPERTY);
    } else {
      setPackagesList([]);
      setTableProperty(DEFAULT_TABLE_PROPERTY);
    }
  };

  const loadPackagesList = useCallback(() => {
    getList();
  }, [dispatch, selectedCustomer, isApproved, vouId]);

  const handleDeliveryApproved = async (item) => {
    const body = {
      customerId: selectedCustomer?.customerId,
      id: item?.id,
    };

    confirmDialog({
      title: <Text t="attention" />,
      message: 'Onaylamak istediğinize emin misiniz?',
      onOk: async () => {
        const action = await dispatch(updatePackages(body));
        if (updatePackages.fulfilled.match(action)) {
          await getList();
          successDialog({
            title: <Text t="successfullySent" />,
            message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
            onOk: async () => {
              dispatch(getPendingNotifications({}));
              if (packagesList.length < 2) {
                window.location.reload();
              } else {
                await loadPackagesList();
              }
            },
            onCancel: () => { },
          });
        }
      },
    });
  };

  const handleCardDetail = (record) => {
    dispatch(setSelectedOrder(record));
    setOrderSummaryCardModalVisible(true);
  };
  const handlepackagesTableChange = useCallback(
    (pageNumber, pageSize) => {
      getList(pageNumber, pageSize);
    },
    [dispatch, selectedCustomer, isApproved, vouId],
  );

  const columnsDelivery = [
    {
      title: <Text t="orderNoUpperCase" />,
      dataIndex: 'orderId',
      key: 'orderId',
      width: '25%',
      render: (text, record) => {
        return (
          <div className="balance-order-list-order-number" onClick={() => handleCardDetail(record)}>
            {text}
          </div>
        );
      },
    },
    {
      title: (
        <span className="d-flex align-items-center">
          <span style={{ marginRight: 10 }}><Text t="packageNumber2" /></span>
          <Tooltip
            title={
              <div>
                <p style={{ color: '#fff', fontWeight: '600', fontSize: 13 }}>
                  <Text t="packageNumber2" />
                </p>
                <span>
                  <Text t="thisIsTheNumberYouNeedToTell" />
                </span>
              </div>
            }
            color="#646363"
            placement="top"
            arrowPointAtCenter={true}
          >
            {''}
            <CustomImage src={iconInfo} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'id',
      key: 'id',
      width: '25%',
    },
    {
      title: <Text t="orderDeliveryDate2" />,
      dataIndex: 'packageDate',
      key: 'packageDate',
      width: '20%',
      responsive: ['md'],
      render: (text) => {
        return <div>{dayjs(text).format('DD/MM/YYYY HH:mm')}</div>;
      },
    },
    {
      title: <Text t="deliveryAddress" />,
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: '40%',
      responsive: ['md'],
      render: (_, record) => {
        return (
          <div className="row-btn-actions">
            {record?.orderStatusName == 'Teslimat Onaylandı' ? (
              <CustomButton
                id="pendingApproval-deliveryApprovalList-custom-btn-disabled"
                className="custom-btn-disabled"
                disabled={true}
              >
                <Text t="approved" />
              </CustomButton>
            ) : (
              <CustomButton
                id="pendingApproval-deliveryApprovalList-custom-btn-delivery-approved"
                onClick={() => handleDeliveryApproved(record)}
                className="custom-btn-delivery-approved"
                buttonAuthName="OrderDeliveryConfirmationGroup"
              >
                <Text t="confirmDelivery" />
              </CustomButton>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <CustomCollapseCard
      className="delivery-approved-card"
      cardTitle={<Text t={collapseHeader} />}
    >
      <CustomTable
        pagination={
          tableProperty?.totalCount > 10
            ? {
              total: tableProperty?.totalCount,
              pageSize: tableProperty?.pageSize,
              current: tableProperty?.currentPage,
              defaultCurrent: 1,
              onChange: (pageNumber, pageSize) => handlepackagesTableChange(pageNumber, pageSize),
            }
            : false
        }
        isScroll={false}
        dataSource={packagesList}
        columns={columnsDelivery}
        rowKey={(record) => `list-${record?.id}`}
        expandedRowKeys={expandedRowsApproved}
        expandable={{
          showExpandColumn: false,
          expandIconColumnIndex: 7,
          onExpand: (expanded, record, key) =>
            expandedRowsApproved === key
              ? setExpandedRowsApproved(null)
              : setExpandedRowsApproved(key),
          expandIcon: isMobil ? getExpandIcon() : null,
          expandedRowRender: isMobil ? getExpandedRowRender(handleDeliveryApproved) : null,
        }}
      />
      <OrderSummaryCardModal
        modalVisible={orderSummaryCardModalVisible}
        handleModalVisible={setOrderSummaryCardModalVisible}
        fromPage="deliveryConfirmations"
      />
    </CustomCollapseCard>
  );
};

DeliveryApprovedList.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};

export default DeliveryApprovedList;
